import _ from 'lodash';
import IdentifiableDto from 'modules/base/dto/IdentifiableDto';
import NamedDto from 'modules/base/dto/NamedDto';

export default class StatusTableDto extends IdentifiableDto {
	constructor() {
		super();
		/** @type {string} */
        this.key = null
		/** @type {string} */
        this.value = null
	}

	/**
	 * @typedef {Object} _StatusTableDtoProps
	 * @property {string} key
	 * @property {string} value
	 *
	 * @typedef {import("../NamedDto").NamedDtoProps & _StatusTableDtoProps} StatusTableDtoProps
	 */
	/**
	 *
	 * @param {StatusTableDtoProps} props
	 * @returns {StatusTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.key = props.key;
		this.value = props.value;

		return this;
	}

	getAsString(key) {
		return super.getAsString(key);
	}
}
